import { Utils } from 'choerodon-ui/dataset';
export default Utils.normalizeLanguage;
